// Temporary diagnostic logging for the "big gap before the first reel's
// iframe starts loading" investigation (real-device Safari network traces
// showed ~9s between the shell's own resources finishing and the game
// iframe's document request even starting). `performance.now()` is
// relative to this document's own timeOrigin, matching the "Time" axis
// origin Safari/Chrome's Network panel waterfall uses for the *shell's*
// requests — so these marks can be lined up directly against that
// waterfall to see whether the delay is happening on the JS side (would
// show up as a gap *between* these console lines) or purely at the
// network/WebKit layer (JS marks would all land within milliseconds of
// each other, proving the iframe's `src` was set almost immediately and
// the stall is downstream of our code entirely).
//
// Safe to leave in — cheap (a handful of console.log calls per page load)
// — but pull it out (and this file) once the gap is root-caused.
export function perfLog(label: string): void {
  // eslint-disable-next-line no-console
  console.log(`[perf] ${label} @ ${performance.now().toFixed(1)}ms`);
}
